import { Option } from '@mui/base'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Radio, Rating } from 'base-ui'

import {
  RATING_DEFAULT_VALUES,
  type RatingRange,
} from '../ProductSearchRefinementStateContext'

type ProductSearchRefinementRatingItemProps = {
  currentRating: RatingRange
  stars: number
}

const RATING_INPUT_NAME = 'rating'

export const ProductSearchRefinementRatingItem: FC<
  ProductSearchRefinementRatingItemProps
> = ({ currentRating, stars }) => {
  const intl = useIntl()

  const starsLabel = intl.formatMessage(
    { id: 'searchResults.label.rating.stars' },
    { value: stars },
  )
  const andMoreLabel = intl.formatMessage({ id: 'searchResults.label.andMore' })
  const ariaLabel =
    stars === RATING_DEFAULT_VALUES.ratingMax
      ? starsLabel
      : `${starsLabel} ${andMoreLabel}`

  return (
    <Option
      aria-label={ariaLabel}
      className="flex cursor-pointer items-center gap-2 py-2 text-m leading-m text-dark-primary-max"
      value={stars}
    >
      {/* Decorative only — aria-selected on the parent <li role="option"> communicates checked state to assistive technologies */}
      <Radio
        checked={stars === currentRating.ratingMin}
        className="pointer-events-none shrink-0"
        data-qa-id={`form-e-rating-star-${stars}`}
        inert
        name={RATING_INPUT_NAME}
        readOnly
        size="small"
        value={stars}
      />
      <Rating className="text-2xl" key={stars} readOnly value={stars} />
      {stars !== RATING_DEFAULT_VALUES.ratingMax && (
        <span className="text-xs text-dark-primary-strong">
          <FormattedMessage id="searchResults.label.andMore" />
        </span>
      )}
    </Option>
  )
}
